import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import ConfigContextProvider from './contexts/ConfigContext.tsx';
import { AuthStateContext, ConfigContext } from './contexts/index.tsx';
import { FullScreenSpinner } from './components/molecules/Spinner.tsx';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import AuthStateContextProvider from './contexts/authStateContext.tsx';
import { buildUrl } from './helpers/utils.ts';
import { View, DimensionValue } from 'react-native';

createRoot(document.getElementById('root')!).render(
  <ConfigContextProvider>
    <ConfigContext.Consumer>
      {(configContext) => {
        if (!configContext) {
          return (
            <View
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100vh' as DimensionValue,
                width: '100vw' as DimensionValue
              }}>
              <FullScreenSpinner />
            </View>
          );
        }

        const authConfig: AuthProviderProps = {
          authority: `${configContext.KEYCLOAK_URL}/realms/${configContext.KEYCLOAK_REALM}/`,
          client_id: configContext.KEYCLOAK_CLIENT_ID,
          resource: configContext.KEYCLOAK_CLIENT_ID,
          // Automatically renew the access token before it expires
          automaticSilentRenew: true,
          // Default sign in redirect
          redirect_uri: buildUrl(window.location.origin),
          // Default sign out redirect
          post_logout_redirect_uri: buildUrl(window.location.origin),
          // Automatically load additional user profile information
          loadUserInfo: true,
          userStore: new WebStorageStateStore({ store: window.localStorage }),
          onSigninCallback: (): void => {
            // See https://github.com/authts/react-oidc-context#getting-started
            window.history.replaceState({}, document.title, window.location.pathname);
          }
        };

        return (
          <AuthProvider {...authConfig}>
            <AuthStateContextProvider>
              <AuthStateContext.Consumer>
                {(authState) => {
                  if (
                    !authState ||
                    (authState.auth.isLoading &&
                      !authState.auth.isAuthenticated &&
                      !authState.auth.user?.access_token)
                  ) {
                    return <FullScreenSpinner />;
                  }

                  return <App />;
                }}
              </AuthStateContext.Consumer>
            </AuthStateContextProvider>
          </AuthProvider>
        );
      }}
    </ConfigContext.Consumer>
  </ConfigContextProvider>
);
